import { AdvertisementTypeEnum } from "@app/types/enums";
import internationalGlobalLogo from "@assets/verticals/international-global-logo-blue.svg";
import SCLogo from "@assets/verticals/standard-chartered-logo.svg";
import Advertisement from "@components/Advertisement/Advertisement";
import PrestitialAd from "@components/Advertisement/PrestitialAd";
import Banner from "@components/Banner/Banner";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { sectionNavigationItems } from "@util/constant";
import { GoogleAdsSlotFactory } from "@util/helpers";

export default function GlobalEnterpriseBanner(): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const slot = sectionNavigationItems["international/global"]
    ? GoogleAdsSlotFactory.lb1(
        sectionNavigationItems["international/global"].link
          .split("/")
          .filter((a) => a !== "")
          .join("/")
      )
    : null;
  return (
    <>
      {sectionNavigationItems["international/global"] ? (
        <SectionMasthead
          link={sectionNavigationItems["international/global"].link}
          masthead={{
            alt: "Global Enterprise logo",
            src: internationalGlobalLogo,
            width: 150,
            height: 50,
          }}
        />
      ) : null}

      <Banner rootClassName="w-full bg-gray-250 py-3">
        <div className="flex flex-row items-center justify-center gap-x-4 lg:justify-end">
          <span className="font-poppins text-base font-light uppercase">
            BROUGHT TO YOU BY
          </span>
          <img
            src={SCLogo}
            alt="Standard Charted Logo"
            width="80"
            height="45"
          />
        </div>
      </Banner>

      {slot ? (
        <>
          <Advertisement
            rootClassName="pb-6"
            adUnitProps={{ type: AdvertisementTypeEnum.LB1, slot: slot }}
          />

          {OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER ? (
            <PrestitialAd slot={slot} />
          ) : null}
        </>
      ) : null}
    </>
  );
}
